import Swal from "sweetalert2";
import i18n from "@/i18n";

export function alertError(title = i18n.global.t('base.prompt'), message) {
    Swal.fire({
        icon: 'error',
        title: title,
        text: message,
        showCancelButton: false,
        confirmButtonText: i18n.global.t('base.done'),
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn btn-info px-5'
        }
    })
}

export function alertErrors(title = i18n.global.t('base.prompt'), message) {
    Swal.fire({
        iconHtml: `<img src="${require('./30.gif')}">`,
       
        title: title,
        text: message,
        showCancelButton: false,
        confirmButtonText: i18n.global.t('base.done'),
        buttonsStyling: false,
        customClass: {
            confirmButton: 'btn btn-info px-5',
          icon: 'border-0'

        }
    })
}

export function successMsg(message) {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    Toast.fire({
        icon: 'success',
        title: message
    })
}

export function errorMsg(message) {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    })

    Toast.fire({
        icon: 'error',
        title: message
    })
}

export function alertComfirm(title = i18n.global.t('base.Confirm to perform this operation?'), message, html) {
    return new Promise((resolve, reject) => {
        Swal.fire({
            icon: 'warning',
            title: title,
            text: message,
            html: html,
            showCancelButton: true,
            cancelButtonText: i18n.global.t('base.cancel'),
            confirmButtonText: i18n.global.t('base.done'),
            buttonsStyling: false,
            customClass: {
                confirmButton: 'btn btn-info px-5 me-3',
                cancelButton: 'btn btn-outline-info px-5'
            }
        }).then(res => {
            if (res.isConfirmed) {
                resolve(true)
            } else {
                resolve(false)
            }
        }).catch(err => {
            reject(err)
        })
    })
}

export function alertComfirmWithTextarea(title = i18n.global.t('base.Confirm to perform this operation?'), message, inputPlaceholder) {
    return new Promise((resolve, reject) => {
        Swal.fire({
            icon: 'warning',
            title: title,
            text: message,
            input: 'textarea',
            inputPlaceholder: inputPlaceholder,
            showCancelButton: true,
            cancelButtonText: i18n.global.t('base.cancel'),
            confirmButtonText: i18n.global.t('base.done'),
            buttonsStyling: false,
            customClass: {
                confirmButton: 'btn btn-info px-5 me-3',
                cancelButton: 'btn btn-outline-info px-5'
            }
        }).then(res => {
            if (res.isConfirmed) {
                resolve(res.value)
            }
        }).catch(err => {
            reject(err)
        })
    })
}
